import { Box, Flex, Heading, VStack, Text } from "@chakra-ui/react"
import { IJobsheet, JobsheetStatus } from "../../../../../interfaces/jobsheets/IJobsheet"
import * as webHelpers from "../../../../../helpers/WebHelpers";
import { useEffect, useState } from "react";
import { IVatCode, VatCodeType } from "../../../../../interfaces/accounting/VatCode";

interface IProps {
    jobsheet: IJobsheet
}

export const Pricing = ({jobsheet}: IProps) => {
    const [vatCode, setVatCode] = useState<IVatCode | null>(null);

    useEffect(() => {
        webHelpers.getAsync<IVatCode>("/api/sales/accounting/vatcode?id=" + jobsheet.value_vat_code).then(res => {
            setVatCode(res);
        });
    }, []);

    return (
        <Box borderWidth='1px' borderColor='gray.400' borderRadius='lg' p={2} h='full'>
            <Flex direction='column' w='full'>
                <Heading mb={2} size='md' color='var(--Able-blue)' p={2} borderBottom='2px' borderColor='gray.200'>Pricing</Heading>

                <VStack pl={2} pr={2}>
                    <Flex w='full' justify='space-between'>
                        <Text>Labour:</Text>
                        <Text>£{jobsheet.value_labour_nett.toFixed(2)}</Text>
                    </Flex>
                    <Flex w='full' justify='space-between'>
                        <Text>Materials:</Text>
                        <Text>£{jobsheet.value_materials_nett.toFixed(2)}</Text>
                    </Flex>
                    <Flex w='full' justify='space-between'>
                        <Text>VAT at {vatCode?.rate ?? "--"}%:</Text>
                        <Text>£{jobsheet.value_vat.toFixed(2)}</Text>
                    </Flex>
                    {vatCode?.type === VatCodeType.ReverseCharge && 
                        <Text as='i' w='full' fontSize='sm'>Reverse Charge</Text>
                    }
                    {jobsheet.value_discount_requested !== 0 &&
                        <Flex w='full' justify='space-between'>
                            <Text>Discount Applied:</Text>
                            {jobsheet.value_discount_is_percentage ?
                                <Text>{jobsheet.value_discount_requested}%</Text>
                                :
                                <Text>- £{String(jobsheet.value_discount_requested).slice(1)}</Text>
                            }
                        </Flex>
                    }
                    <Flex w='full' justify='space-between'>
                        <Text>Total:</Text>
                        <Text>£{jobsheet.value_gross.toFixed(2)}</Text>
                    </Flex>
                    {jobsheet.value_paid > 0 &&
                        <Flex w='full' justify='space-between'>
                            <Text>Balance Paid:</Text>
                            <Text>£{jobsheet.value_paid.toFixed(2)}</Text>
                        </Flex>
                    }
                    <Flex w='full' justify='space-between'>
                        <Text as='b' color='var(--Able-blue)'>Balance Due:</Text>
                        <Text as='b'>£{(jobsheet.value_gross - jobsheet.value_paid).toFixed(2)}</Text>
                    </Flex>
                </VStack>
                {jobsheet.status <= JobsheetStatus.Pending && 
                    <Text as={"i"} textAlign={"right"} fontSize={"md"} pr={2}>All pricing is subject to site survey</Text>
                }
            </Flex>
        </Box>
    )
}